import { render, staticRenderFns } from "./LinkDigiBoards.vue?vue&type=template&id=90725428&scoped=true"
import script from "./LinkDigiBoards.vue?vue&type=script&lang=js"
export * from "./LinkDigiBoards.vue?vue&type=script&lang=js"
import style0 from "./LinkDigiBoards.vue?vue&type=style&index=0&id=90725428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90725428",
  null
  
)

export default component.exports